import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Lazyload from 'react-lazy-load'
import VideoCarousel from './VideoCarousel'

function VirtualMarathon() {
  const { t } = useTranslation()
  const [isMobile, setIsMobile] = useState(false)

  const wistiaVideoUrls = [
    'https://www.youtube.com/embed/4h9eRm4hNe0',
    'https://www.youtube.com/embed/LSX4pxSB6Qw',
    'https://www.youtube.com/embed/L_39IykL-O4',
  ]

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return (
    <>
      <section className="bg-dark multi-activity virtual-marathon hero-bg position-relative section-pdn pt-8 soln-hero rt-1">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12">
            <p className="font-weight-semibold hero-heading text-center no-br vm-h1">
              <Trans>One Day</Trans>
            </p>
            <p className="font-weight-semibold hero-heading text-center no-br vm-h2">
              <Trans>One Global Workforce.</Trans>
            </p>
            <h1 className="mt-0 pt-0 font-weight-bold hero-heading text-center no-br">
              <Trans>One Virtual Marathon.</Trans>
            </h1>
            <p className="hero-para font-weight-normal text-center no-br">
              <Trans>
                Organize a one-day virtual marathon for your global workforce with Vantage Fit. Unify teams across{' '}
                <br /> geographies, boost engagement, and promote wellness—all at once.
              </Trans>
            </p>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative pl-0 pr-0">
        <div className="">
          <div className="feat_box  p-md-5 p-2  shadow active_challenge">
            <div className="container custom_container p-0 rl-bg">
              <div className="col-12">
                <div className="col-12 pt-5">
                  <h2 className="font-weight-semibold text-center py-2 section-heading">
                    <Trans>Race Levels</Trans>
                  </h2>
                  <p className="section-para text-center">
                    <Trans>
                      Our Virtual Marathon is here to inspire runners of all levels! Whether you are a beginner,
                      intermediate, <br /> or seasoned runners, we have the perfect race for you. Each category comes
                      with its unique rewards!
                    </Trans>
                  </p>
                  {/* <p className='section-para font-weight-normal'>Track health metrics and participation seamlessly to boost Engagement and well-being.</p> */}
                </div>
              </div>
              <div className="col-12 cta-img">
                <div className="d-flex justify-content-center race-level">
                  <img
                    className="img-responsive"
                    loading="lazy"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1733125823/VantageFit/2024/virtual-marathon/Group_400.png`
                    )}
                    width="200"
                    height="200"
                    alt="1"
                  />
                  <img
                    className="img-responsive"
                    loading="lazy"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1733125823/VantageFit/2024/virtual-marathon/Group_401.png`
                    )}
                    width="200"
                    height="200"
                    alt="1"
                  />
                  <img
                    className="img-responsive"
                    loading="lazy"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1733125824/VantageFit/2024/virtual-marathon/Group_402.png`
                    )}
                    width="200"
                    height="200"
                    alt="1"
                  />
                </div>
              </div>
            </div>
          </div>
          <h2 className="section-heading section-heading-top font-weight-semibold text-center">
            <Trans>Custom Distances, Seamless Connection, Instant Rewards</Trans>
          </h2>
          <div className="">
            <div className="feat_box sect-white-col-2 shadow active_challenge">
              <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                <div className="col-12 col-md-5">
                  <div className="col-12">
                    <h2 className="font-weight-semibold py-2 section-heading">
                      <Trans>Global Participation</Trans>
                    </h2>
                    {/* <p className='section-para font-weight-normal'>Track health metrics and participation seamlessly to boost Engagement and well-being.</p> */}
                    <div>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Employees from different time zones and regions can participate in the same event, fostering
                            inclusivity and collaboration.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Our platform automatically adjusts for time zone differences, ensuring all participants feel
                            connected.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Vantage Fit’s Virtual Marathon is designed for simplicity—minimal setup with maximum impact.
                          </Trans>
                        </p>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7 cta-img">
                  <div className="d-flex justify-content-center">
                    <img
                      className="img-responsive"
                      src={t(
                        `https://res.cloudinary.com/vantagecircle/image/upload/v1732875319/VantageFit/2024/virtual-marathon/Global_Participation.png`
                      )}
                      loading="lazy"
                      alt="All-in-One Wellness Dashboard"
                      width="550"
                      height="600"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="feat_box sect-white-col-2 shadow active_challenge">
              <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                <div className="col-12 col-md-5">
                  <div className="col-12">
                    <h2 className="font-weight-semibold py-2 section-heading">
                      <Trans>Live Leaderboard</Trans>
                    </h2>
                    {/* <p className='section-para font-weight-normal'>Dive into employee health metrics and garner in-depth insights for enhanced well-being.</p> */}
                    <div>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            The live leaderboard keeps participants engaged with real-time updates on rankings,
                            progress, and achievements.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Encourage camaraderie and competition by showcasing individual and team standings.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Dynamic updates motivate employees to push their limits and stay active during the event.
                          </Trans>
                        </p>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7 cta-img">
                  <div className="d-flex justify-content-center">
                    <img
                      className="img-responsive"
                      src={t(
                        `https://res.cloudinary.com/vantagecircle/image/upload/v1736329269/VantageFit/2025/Live_Leaderboard_1.png`
                      )}
                      loading="lazy"
                      alt="Empower HR"
                      width="644"
                      height="600"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="feat_box sect-white-col-2 shadow active_challenge">
              <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                <div className="col-12 col-md-5">
                  <div className="col-12">
                    <h2 className="font-weight-semibold py-2 section-heading">
                      <Trans>Multiple Distance Goals</Trans>
                    </h2>
                    {/* <p className='section-para font-weight-normal'>Log meals and monitor food entries for tailored health insights  and optimized well-being.</p> */}
                    <div>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Employees can choose between 5 km, 10 km, or 21 km challenges, ensuring inclusivity for all
                            fitness levels.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Each participant earns points based on the distance they cover, encouraging personal
                            achievements while contributing to team success.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Flexible distance goals make the event accessible to everyone, from beginners to seasoned
                            runners.
                          </Trans>
                        </p>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7 cta-img">
                  <div className="d-flex justify-content-center">
                    <img
                      className="img-responsive"
                      src={t(
                        `https://res.cloudinary.com/vantagecircle/image/upload/v1732875320/VantageFit/2024/virtual-marathon/Multiple_Distance_Goals.png`
                      )}
                      loading="lazy"
                      alt="Nutrition and Calorie Tracker"
                      width="525"
                      height="600"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="feat_box sect-white-col-2 shadow active_challenge">
              <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                <div className="col-12 col-md-5">
                  <div className="col-12">
                    <h2 className="font-weight-semibold py-2 section-heading">
                      <Trans>Recognition Through Badges and Incentivization</Trans>
                    </h2>
                    {/* <p className='section-para font-weight-normal'>Harness the power of movement with analytics to fuel your fitness journey.</p> */}
                    <div>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Participants earn badges for completing milestones (e.g., 5 km, 10 km, 21 km), creating a
                            sense of accomplishment.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            HR managers can customize rewards through gift cards, wellness perks, or company specific
                            incentives to align with organizational goals. This ensures a comprehensive physical
                            wellness suite.
                          </Trans>
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">
                          <Trans>
                            Recognition fosters a culture of appreciation, boosting morale and long-term engagement.
                          </Trans>
                        </p>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7 cta-img">
                  <div className="d-flex justify-content-center">
                    <img
                      className="img-responsive"
                      src={t(
                        `https://res.cloudinary.com/vantagecircle/image/upload/v1736329269/VantageFit/2025/Recognition_Through_Badges_and_Incentivization_1.png`
                      )}
                      loading="lazy"
                      alt="The Physical Wellness Suite"
                      width="540"
                      height="600"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="position-relative z1 testi-wrap py-5">
        <div className="container custom_container px-6">
          <div className="testi-video-wrapper">
            <div className="row col-12 d-flex justify-content-between align-items-center p0">
              <div className="col-12 col-md-4 h-full p0">
                <h2 className="py-2 section-heading no-br">
                  <Trans>
                    Real people, <br />
                    Real results
                  </Trans>
                </h2>
                <p className="section-para">
                  <Trans>Vantage Fit speaks for itself, but our customer reviews speak even louder.</Trans>
                </p>
              </div>
              <div className="col-12 col-md-8 px-0">
                <div className="">
                  <Lazyload offset={300}>
                    <VideoCarousel videoUrls={wistiaVideoUrls} />
                  </Lazyload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12">
            <h2 className="section-heading text-center no-br">
              <Trans>
                Lead the way with the Virtual Marathon <br /> and inspire your team to thrive!
              </Trans>
            </h2>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default VirtualMarathon
